var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NgZone } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { CHANGE_ACTIVITY, ChangeActivityFailureAction, ChangeActivitySuccessAction, CREATE_DEFAULT_CONFIGURATION, CREATE_DEFAULT_CONFIGURATION_SUCCESS, CREATE_PROJECT, CREATE_PROJECT_SUCCESS, CreateDefaultConfigurationFailureAction, CreateDefaultConfigurationSuccessAction, CreateProjectFailureAction, CreateProjectSuccessAction, GET_PROJECT, GET_PROJECT_FAILURE, GET_PROJECTS_WITH_STATS, GET_PROJECTS_WITH_STATS_SUCCESS, GetProjectFailureAction, GetProjectSuccessAction, GetProjectsWithStatsFailureAction, GetProjectsWithStatsSuccessAction, REMOVE_PROJECT, REMOVE_PROJECT_SUCCESS, RemoveProjectFailureAction, RemoveProjectSuccessAction, UPDATE_PROJECT_CONFIGURATION, UPDATE_PROJECT_CONFIGURATION_SUCCESS, UPDATE_PROJECT_STYLE, UPDATE_PROJECT_STYLE_SUCCESS, UpdateProjectConfigurationFailureAction, UpdateProjectConfigurationSuccessAction, UpdateProjectStyleFailureAction, UpdateProjectStyleSuccessAction } from './projects.action';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { ProjectsService } from './projects.service';
import { of } from 'rxjs/observable/of';
import { Router } from '@angular/router';
import { mapResponse, mapSingleProject } from '../shared/domain/configurationMapper';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { LeadGenerationConfigurationService } from '../shared/services/lead-generation-configuration.service';
import { ToastrService } from 'ngx-toastr';
import { LeadGenerationStylesService } from '../shared/services/lead-generation-styles.service';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../shared/services/account.service';
import { EMPTY } from 'rxjs';
var ProjectsEffects = /** @class */ (function () {
    function ProjectsEffects(actions$, toastr, leadGenerationService, leadGenerationStylesService, projectsService, crazyCallService, router, zone, translate, accountService) {
        var _this = this;
        this.actions$ = actions$;
        this.toastr = toastr;
        this.leadGenerationService = leadGenerationService;
        this.leadGenerationStylesService = leadGenerationStylesService;
        this.projectsService = projectsService;
        this.crazyCallService = crazyCallService;
        this.router = router;
        this.zone = zone;
        this.translate = translate;
        this.accountService = accountService;
        this.getProjects$ = this.actions$.pipe(ofType(GET_PROJECTS_WITH_STATS), switchMap(function () {
            return _this.projectsService
                .projectsWithStats()
                .pipe(map(function (response) { return new GetProjectsWithStatsSuccessAction(response); }), catchError(function (error) { return of(new GetProjectsWithStatsFailureAction(error)); }));
        }));
        this.getProject$ = this.actions$.pipe(ofType(GET_PROJECT), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.projectsService
                .singleProject(payload.id)
                .pipe(map(function (project) {
                return new GetProjectSuccessAction(mapSingleProject(project, _this.crazyCallService.account, _this.crazyCallService.appId));
            }), catchError(function (error) { return of(new GetProjectFailureAction(error)); }));
        }));
        this.createProject$ = this.actions$.pipe(ofType(CREATE_PROJECT), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.leadGenerationService
                .createProject(payload)
                .pipe(map(function (response) { return new CreateProjectSuccessAction(response); }), catchError(function (error) { return of(new CreateProjectFailureAction(error)); }));
        }));
        this.createDefaultConfiguration = this.actions$.pipe(ofType(CREATE_DEFAULT_CONFIGURATION), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.leadGenerationService
                .saveDefaultConfiguration(payload)
                .pipe(map(function (response) { return mapResponse(response.body); }), map(function (config) { return new CreateDefaultConfigurationSuccessAction(config); }), catchError(function (error) { return of(new CreateDefaultConfigurationFailureAction(error)); }));
        }));
        this.afterDefaultConfiguration = this.actions$.pipe(ofType(CREATE_DEFAULT_CONFIGURATION_SUCCESS), map(function (action) { return action.payload; }), switchMap(function () { return _this.accountService.accountConfiguredData$.map(function (x) { return x.data || EMPTY; }); }), // redirect only when account is fully configured
        tap(function (config) {
            var projectId = config.projectId || 1;
            return _this.zone.run(function () {
                _this.router.navigate(['lead-generation', 'projects', projectId, 'settings']);
            });
        }));
        this.changeProjectActivity = this.actions$.pipe(ofType(CHANGE_ACTIVITY), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.projectsService
                .changeActivity(payload.projectId, payload.active)
                .pipe(map(function (response) { return new ChangeActivitySuccessAction(response); }), catchError(function (error) { return of(new ChangeActivityFailureAction(error)); }));
        }));
        this.updateProjectConfiguration = this.actions$.pipe(ofType(UPDATE_PROJECT_CONFIGURATION), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.leadGenerationService
                .updateConfiguration(payload)
                .pipe(map(function (response) { return new UpdateProjectConfigurationSuccessAction(response); }), catchError(function (error) { return of(new UpdateProjectConfigurationFailureAction(error)); }));
        }));
        this.updateProjectStyle = this.actions$.pipe(ofType(UPDATE_PROJECT_STYLE), map(function (action) { return action.payload; }), switchMap(function (request) {
            return _this.leadGenerationStylesService
                .saveDb(request)
                .pipe(map(function (response) { return new UpdateProjectStyleSuccessAction(response); }), catchError(function (error) { return of(new UpdateProjectStyleFailureAction(error)); }));
        }));
        this.projectCreationSuccess$ = this.actions$.pipe(ofType(CREATE_PROJECT_SUCCESS), tap(function (response) {
            _this.translate.get('LEAD_GENERATION.TOAST.PROJECT_ADDED').subscribe(function (res) {
                _this.toastr.success(res);
            });
            return _this.zone.run(function () {
                return _this.router.navigateByUrl("/lead-generation/projects/" + response.payload.projectId + "/creator/bubble");
            });
        }));
        this.updateProjectSuccess$ = this.actions$.pipe(ofType(UPDATE_PROJECT_CONFIGURATION_SUCCESS, UPDATE_PROJECT_STYLE_SUCCESS), tap(function () {
            _this.translate.get('LEAD_GENERATION.TOAST.CONFIGURATION_UPDATED').subscribe(function (res) {
                _this.toastr.success(res);
            });
        }));
        this.addOrigin$ = this.actions$.pipe(ofType(UPDATE_PROJECT_CONFIGURATION_SUCCESS, UPDATE_PROJECT_STYLE_SUCCESS), map(function (action) { return action.payload; }), switchMap(function (configuration) {
            return configuration.domainName ? _this.leadGenerationService.addOrigin(configuration.domainName) : EMPTY;
        }));
        this.getProjectSuccess$ = this.actions$.pipe(ofType(GET_PROJECT_FAILURE), tap(function () { return _this.zone.run(function () { return _this.router.navigate(['/lead-generation', 'projects']); }); }));
        this.getProjectsSuccess$ = this.actions$.pipe(ofType(GET_PROJECTS_WITH_STATS_SUCCESS), map(function (action) { return action.payload; }), 
        // temporarily, until multiple projects are implemented
        tap(function (projects) {
            var path = projects.length ? ['projects', projects[0].id, 'installation'] : ['new-project', 'settings'];
            return _this.zone.run(function () { return _this.router.navigate(['/lead-generation'].concat(path)); });
        }));
        this.removeProject = this.actions$.pipe(ofType(REMOVE_PROJECT), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.projectsService
                .removeProject(payload)
                .pipe(map(function () { return new RemoveProjectSuccessAction(); }), catchError(function (error) { return of(new RemoveProjectFailureAction(error)); }));
        }));
        this.removeProjectAction$ = this.actions$.pipe(ofType(REMOVE_PROJECT_SUCCESS), tap(function () {
            _this.translate.get('LEAD_GENERATION.TOAST.PROJECT_REMOVED').subscribe(function (res) {
                _this.toastr.success(res);
            });
            return _this.zone.run(function () { return _this.router.navigate(['/lead-generation', 'projects']); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "getProjects$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "getProject$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "createProject$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "createDefaultConfiguration", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], ProjectsEffects.prototype, "afterDefaultConfiguration", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "changeProjectActivity", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "updateProjectConfiguration", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "updateProjectStyle", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "projectCreationSuccess$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "updateProjectSuccess$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], ProjectsEffects.prototype, "addOrigin$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "getProjectSuccess$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "getProjectsSuccess$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "removeProject", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], ProjectsEffects.prototype, "removeProjectAction$", void 0);
    return ProjectsEffects;
}());
export { ProjectsEffects };
